<template>
  <!-- 选择打款日期 -->
  <div>
    <Modal v-model="visible" title="打款时间" :mask-closable="false" :footer-hide="true" width="500px" class="my-modal">
      <div class="confirm-box">
        <span style="margin-right: 10px">打款时间</span>
        <DatePicker type="date" transfer v-model.trim="formData.paymentTime" format="yyyy-MM-dd" placeholder="选择日期"></DatePicker>
      </div>
      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="save()">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import filter from '@/api/filter';
import { common } from '@/api/mixins';

export default {
  mixins: [common],
  components: {},
  data() {
    return {
      visible: false,
      formData: {
        paymentTime: '' //打款时间
      }
    };
  },
  computed: {},
  methods: {
    save() {
      if (this.formData.paymentTime) {
        this.formData.paymentTime = filter.filterTime(this.formData.paymentTime, 'YYYY-MM-DD');
        this.$emit('save', this.formData);
      } else {
        this.$notice.msg('请选择打款日期');
      }
    },
    open(formData) {
      this.formData = formData;
      this.visible = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.my-modal {
  /deep/ .ivu-modal-body {
    padding-top: 20px;
  }
  /deep/.ivu-tooltip-rel {
    .ivu-btn {
      margin-left: 10px;
    }
  }
}
</style>
